import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Política de Privacidad"
        description="Política de privacidad de erm-media. Información sobre cómo recopilamos, usamos y protegemos tus datos personales de acuerdo con el RGPD."
        keywords="política de privacidad, RGPD, protección de datos, privacidad, datos personales"
        canonicalUrl="https://erm-media.com/privacidad"
        type="article"
      />
      <Header />
      <main className="flex-1 container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold text-foreground mb-8">
          Política de Privacidad
        </h1>

        <div className="prose prose-slate dark:prose-invert max-w-none space-y-6">
          <p className="text-muted-foreground">
            <strong>Fecha de última actualización:</strong> <span suppressHydrationWarning>{new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
          </p>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">1. Introducción</h2>
            <p className="text-muted-foreground leading-relaxed">
              En erm-media, respetamos tu privacidad y estamos comprometidos con la protección de tus datos personales.
              Esta Política de Privacidad explica cómo recopilamos, usamos, almacenamos y protegemos tu información cuando
              visitas nuestro sitio web y utilizas nuestros servicios.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">2. Información que Recopilamos</h2>
            <h3 className="text-xl font-semibold text-foreground">2.1 Información que nos proporcionas</h3>
            <p className="text-muted-foreground leading-relaxed">
              Cuando te pones en contacto con nosotros a través de nuestro formulario de contacto, podemos recopilar:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Nombre completo</li>
              <li>Dirección de correo electrónico</li>
              <li>Número de teléfono (opcional)</li>
              <li>Empresa u organización (opcional)</li>
              <li>Mensaje o consulta que nos envías</li>
            </ul>

            <h3 className="text-xl font-semibold text-foreground mt-4">2.2 Información recopilada automáticamente</h3>
            <p className="text-muted-foreground leading-relaxed">
              Cuando visitas nuestro sitio web, recopilamos automáticamente cierta información, incluyendo:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Dirección IP</li>
              <li>Tipo de navegador y versión</li>
              <li>Sistema operativo</li>
              <li>Páginas visitadas y tiempo de permanencia</li>
              <li>Fuente de referencia (cómo llegaste a nuestro sitio)</li>
              <li>Cookies y tecnologías similares</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">3. Cómo Usamos tu Información</h2>
            <p className="text-muted-foreground leading-relaxed">
              Utilizamos la información recopilada para los siguientes propósitos:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Responder a tus consultas y solicitudes de información</li>
              <li>Proporcionar y mejorar nuestros servicios</li>
              <li>Enviar comunicaciones relacionadas con nuestros servicios</li>
              <li>Analizar el uso del sitio web para mejorar la experiencia del usuario</li>
              <li>Cumplir con obligaciones legales y regulatorias</li>
              <li>Prevenir fraudes y garantizar la seguridad de nuestros servicios</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">4. Base Legal para el Tratamiento</h2>
            <p className="text-muted-foreground leading-relaxed">
              Procesamos tus datos personales en base a:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li><strong>Consentimiento:</strong> Cuando nos proporcionas tus datos voluntariamente a través de nuestro formulario</li>
              <li><strong>Interés legítimo:</strong> Para mejorar nuestros servicios y proteger nuestra plataforma</li>
              <li><strong>Obligación legal:</strong> Cuando sea requerido por ley</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">5. Compartir Información</h2>
            <p className="text-muted-foreground leading-relaxed">
              No vendemos, intercambiamos ni transferimos tu información personal a terceros, excepto en los siguientes casos:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li><strong>Proveedores de servicios:</strong> Podemos compartir información con proveedores de confianza que nos ayudan
              a operar nuestro sitio web (hosting, análisis, servicios de correo electrónico)</li>
              <li><strong>Requisitos legales:</strong> Cuando sea necesario para cumplir con la ley, regulaciones,
              procesos legales o solicitudes gubernamentales</li>
              <li><strong>Protección de derechos:</strong> Para proteger nuestros derechos, propiedad o seguridad,
              o los de nuestros usuarios</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">6. Cookies y Tecnologías de Seguimiento</h2>
            <p className="text-muted-foreground leading-relaxed">
              Utilizamos cookies y tecnologías similares para mejorar tu experiencia en nuestro sitio web:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li><strong>Cookies esenciales:</strong> Necesarias para el funcionamiento básico del sitio</li>
              <li><strong>Cookies analíticas:</strong> Para entender cómo los usuarios interactúan con nuestro sitio</li>
              <li><strong>Cookies de funcionalidad:</strong> Para recordar tus preferencias</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Puedes configurar tu navegador para rechazar cookies, aunque esto puede afectar la funcionalidad del sitio.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">7. Seguridad de los Datos</h2>
            <p className="text-muted-foreground leading-relaxed">
              Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger tu información personal
              contra acceso no autorizado, alteración, divulgación o destrucción. Estas medidas incluyen:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li>Cifrado SSL/TLS para la transmisión de datos</li>
              <li>Acceso restringido a datos personales</li>
              <li>Sistemas de monitoreo y protección contra amenazas</li>
              <li>Revisiones regulares de nuestras prácticas de seguridad</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">8. Retención de Datos</h2>
            <p className="text-muted-foreground leading-relaxed">
              Conservamos tu información personal solo durante el tiempo necesario para cumplir con los propósitos descritos
              en esta política, a menos que la ley requiera o permita un período de retención más largo. Cuando tus datos
              ya no sean necesarios, los eliminaremos de forma segura.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">9. Tus Derechos</h2>
            <p className="text-muted-foreground leading-relaxed">
              De acuerdo con la normativa de protección de datos (RGPD), tienes los siguientes derechos:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
              <li><strong>Derecho de acceso:</strong> Solicitar una copia de tus datos personales</li>
              <li><strong>Derecho de rectificación:</strong> Corregir datos inexactos o incompletos</li>
              <li><strong>Derecho de supresión:</strong> Solicitar la eliminación de tus datos</li>
              <li><strong>Derecho de oposición:</strong> Oponerte al procesamiento de tus datos</li>
              <li><strong>Derecho de portabilidad:</strong> Recibir tus datos en un formato estructurado</li>
              <li><strong>Derecho de limitación:</strong> Solicitar la limitación del procesamiento</li>
              <li><strong>Derecho a retirar el consentimiento:</strong> En cualquier momento</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Para ejercer estos derechos, puedes contactarnos a través de los medios proporcionados en la sección de contacto.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">10. Transferencias Internacionales</h2>
            <p className="text-muted-foreground leading-relaxed">
              Algunos de nuestros proveedores de servicios pueden estar ubicados fuera de tu país de residencia.
              En estos casos, nos aseguramos de que se implementen salvaguardas apropiadas para proteger tu información
              personal de acuerdo con esta política y la legislación aplicable.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">11. Enlaces a Sitios de Terceros</h2>
            <p className="text-muted-foreground leading-relaxed">
              Nuestro sitio web puede contener enlaces a sitios web de terceros. No somos responsables de las prácticas
              de privacidad o el contenido de estos sitios. Te recomendamos leer las políticas de privacidad de cualquier
              sitio web de terceros que visites.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">12. Privacidad de Menores</h2>
            <p className="text-muted-foreground leading-relaxed">
              Nuestros servicios no están dirigidos a menores de 18 años. No recopilamos conscientemente información
              personal de menores. Si descubrimos que hemos recopilado información de un menor, la eliminaremos
              inmediatamente.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">13. Cambios en esta Política</h2>
            <p className="text-muted-foreground leading-relaxed">
              Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier momento. Los cambios
              entrarán en vigor inmediatamente después de su publicación en esta página. La fecha de última actualización
              se indicará al principio de esta política. Te recomendamos revisar periódicamente esta página para estar
              informado sobre cómo protegemos tu información.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">14. Contacto</h2>
            <p className="text-muted-foreground leading-relaxed">
              Si tienes preguntas, comentarios o inquietudes sobre esta Política de Privacidad, o si deseas ejercer
              tus derechos de protección de datos, puedes contactarnos a través de:
            </p>
            <ul className="list-none text-muted-foreground space-y-2 ml-4">
              <li><strong>Empresa:</strong> erm-media</li>
              <li><strong>Sitio web:</strong> Formulario de contacto disponible en nuestra página principal</li>
            </ul>
          </section>

          <div className="border-t border-border pt-6 mt-8">
            <p className="text-sm text-muted-foreground">
              Al utilizar nuestro sitio web, aceptas los términos de esta Política de Privacidad.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
